export default {
    state: {
        unit_groups: []
    },
    mutations: {
        setUnitGroups (state, payload) {
            state.unit_groups = payload
        }
    },
    actions: {
        getUnitGroups (context, publication_id) {
            return new Promise((resolve, reject) => {
                this._vm.axios.get('/api/unit_groups/' + publication_id)
                .then(response => {
                    let group_data = []

                    if (response.data) {
                        group_data = response.data
                    }

                    _.forEach(group_data, publication => {
                        _.forEach(publication.unit_groups, unit_group => {
                            // Unit Group Visibility setup
                            if (
                                !localStorage.getItem('Publication' + publication_id + 'Group' + unit_group.id) ||
                                localStorage.getItem('Publication' + publication_id + 'Group' + unit_group.id) == 'true' ||
                                localStorage.getItem('Publication' + publication_id + 'Group' + unit_group.id) == 'undefined'
                            ) {
                                this._vm.$set(unit_group, 'visible', true)
                            } else {
                                this._vm.$set(unit_group, 'visible', false)
                            }
                            // Units Visibility Setup
                            if (
                                !localStorage.getItem('Publication' + publication_id + 'Group' + unit_group.id + 'Units') ||
                                localStorage.getItem('Publication' + publication_id + 'Group' + unit_group.id + 'Units') == 'true' ||
                                localStorage.getItem('Publication' + publication_id + 'Group' + unit_group.id + 'Units') == 'undefined'
                            ) {
                                this._vm.$set(unit_group, 'units_visible', true)
                            } else {
                                this._vm.$set(unit_group, 'units_visible', false)
                            }

                            this._vm.$set(unit_group, 'old_order_number', unit_group.order_number)
                        })
                        publication.unit_groups = _.orderBy(publication.unit_groups, 'order_number')
                    })

                    context.commit('setUnitGroups', group_data)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        }
    }
}
